import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart, money } = useApp();
  const navigate = useNavigate();

  return (
    <div className="max-w-[1500px] mx-auto px-6 py-16 min-h-[60vh]">
      <h1 className="font-serif text-4xl text-center mb-12">Your Wishlist</h1>
      {wishlist.length === 0 ? (
        <div className="text-center py-20">
          <p className="font-serif text-2xl mb-3">Your wishlist is empty</p>
          <p className="text-sm mb-6" style={{ color: "var(--ev-muted)" }}>Save pieces from across the Maison to revisit them later.</p>
          <button onClick={() => navigate("/")} className="btn-luxe">Explore the Collections</button>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {wishlist.map((p) => (
            <div key={p.id} data-testid={`wishlist-item-${p.slug}`} className="group">
              <div className="img-zoom relative aspect-[3/4] bg-ev-bg cursor-pointer" onClick={() => navigate(`/product/${p.slug}`)}>
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                <button onClick={(e) => { e.stopPropagation(); toggleWishlist(p); }}
                  className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/80 rounded-full"><X size={16} /></button>
              </div>
              <div className="pt-3 text-center">
                <div className="font-serif text-lg">{p.name}</div>
                <div className="text-xs uppercase tracking-wide mb-2" style={{ color: "var(--ev-muted)" }}>{p.storefront}</div>
                <div className="text-sm mb-3">{money(p.price_usd)}</div>
                <button onClick={() => addToCart(p)} className="text-[0.62rem] tracking-[0.22em] uppercase border-b pb-0.5" style={{ borderColor: "var(--ev-text)" }}>Add to Bag</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
